// After a deploy, a client still running the previous build requests lazy chunks
// whose hashes no longer exist. Reload to pick up the current build — at most once
// per minute, so a genuinely broken chunk can't trap the page in a reload loop.
const RELOAD_KEY = "zk:chunk-reload-at";
const RELOAD_COOLDOWN_MS = 60_000;

window.addEventListener("vite:preloadError", (event) => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (Date.now() - last < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});

import("./main");
